export enum CaseSizeUom {
  INCH = 'INCH',
  CM = 'CM',
  MM = 'MM'
}
